<template>
	<div class="dashboard-wrapper">
		<h1>Welcome to {{ getSiteBrand }}!</h1>
		<p>You can access all your programs and reports by clicking the <img src="@/assets/img/IconFlightDeckLight.png" style="filter: invert(100%); height: 0.75em;"> icon.
			Check out the <span @click="playVideo(473580389)" class="dashboard-link">Dashboard Overview</span> for some quick tips.</p>
		<div class="dashboard-flight-deck">
			<div>
                <div class="two-columns">
					<div class="dashboard-tile orderssales">
						<div class="title">Recent Sales</div>
						<div class="statistic">
							<div class="stat" v-if="isLoading('getNavCenterStats')"> <div class="loader"></div> 
						</div>
						<div class="stat" v-else>
							${{ recent_orders }}
						</div>
							<div class="caption">Last 7 days</div>
						</div>
						<router-link :to="getMenuItemPoliciesByLink['/orders-sales/orders'] && getMenuItemPoliciesByLink['/orders-sales/orders']['not_allowed'] == 1 ? '/' : '/orders-sales/orders'" class="dashboard-link">Manage Orders &amp; Sales</router-link>
					</div>
					<div class="dashboard-tile inventory">
						<div class="title">Store Inventory</div>
						<div class="statistic">
							<div class="stat" v-if="isLoading('getNavCenterStats')"> <div class="loader"></div>
						</div>
						<div class="stat" v-else>
							${{ store_inventory }}
						</div>
							<div class="caption">Current price on hand inventory</div>
						</div>
						<router-link :to="getMenuItemPoliciesByLink['/reports/inventory-management'] && getMenuItemPoliciesByLink['/reports/inventory-management']['not_allowed'] == 1 ? '/' : '/reports/inventory-management'" class="dashboard-link">Inventory Management Report</router-link>
					</div>
				</div>
				<div class="four-columns">
					<div class="dashboard-tile compliance">
						<div class="title">Logbook Dispositions</div>
						<div class="statistic">
							<div class="stat" v-if="isLoading('getNavCenterStats')"> <div class="loader"></div>
						</div>
						<div class="stat" v-else>
							{{ recent_dispositions || 0 }}
						</div>
							<div class="caption">Last 5 Business Days</div>
						</div>
						<router-link :to="getMenuItemPoliciesByLink['/logbooks'] && getMenuItemPoliciesByLink['/logbooks']['not_allowed'] == 1 ? '/' : '/logbooks'" class="dashboard-link">Manage Logbooks</router-link>
					</div>
					<div class="dashboard-tile promotion">
						<div class="title">Promo Packs</div>
						<div class="statistic">
							<div class="stat" v-if="isLoading('getNavCenterStats')"> <div class="loader"></div>
						</div>
						<div class="stat" v-else>
							{{ push_packs || 0 }}
						</div>
							<div class="caption">Currently Available</div>
						</div>
						<router-link :to="getMenuItemPoliciesByLink['/promotions/promo-packs'] && getMenuItemPoliciesByLink['/promotions/promo-packs']['not_allowed'] == 1 ? '/' : '/promotions/promo-packs'" class="dashboard-link">Manage Promo Packs</router-link>
						<div v-if="opted_out" style="position: absolute; top: 5px; right: 5px; text-align: center; font-size: 0.9em; width: 5em; padding: 0.25em; background-color: rgba(0,0,0,.5);">Opted Out {{ opted_out }}</div>
					</div>
					<div class="dashboard-tile customers">
						<div class="title">Customers</div>
						<div class="statistic">
							<div class="stat" v-if="isLoading('getNavCenterStats')"> <div class="loader"></div>
						</div>
						<div class="stat" v-else>
							{{ customer_count || 0 }}
						</div>
							<div class="caption">Current list</div>
						</div>
						<router-link :to="getMenuItemPoliciesByLink['/customers/contacts'] && getMenuItemPoliciesByLink['/customers/contacts']['not_allowed'] == 1 ? '' : '/customers/contacts'" class="dashboard-link">Manage Customers</router-link>
					</div>
					<div class="dashboard-tile dashboard">
						<div class="title">Reorder Cart</div>
						<div class="statistic">
							<div class="stat" v-if="isLoading('getNavCenterStats')"> <div class="loader"></div>
						</div>
						<div class="stat" v-else>
							{{ reorder_cart || 0 }}
						</div>
							<div class="caption">In Your Reorder Cart</div>
						</div>
						<router-link :to="getMenuItemPoliciesByLink['/legacy/batchordermaintenance.php'] && getMenuItemPoliciesByLink['/legacy/batchordermaintenance.php']['not_allowed'] == 1 ? '/' : '/legacy/batchordermaintenance.php'" class="dashboard-link">Manage Reorder Cart</router-link>
					</div>
				</div>

				<div v-if="new_features.length > 0" :class="newFeaturesColumns">
					<div v-for="(feature, index) in new_features" :class="['dashboard-tile', 'new-features', { withlink: feature.link }]">
						<div class="title">{{ feature.title }}</div>
						<div v-html="feature.content"></div>
						<a v-if="feature.link.indexOf('http') > -1" :href="feature.link" class="alert-link" target="_blank">{{ feature.link_label }}...</a>
						<router-link v-else-if="feature.link" :to="feature.link" class="alert-link">{{ feature.link_label}}...</router-link>
					</div>
				</div>
			</div>

			<div v-if="alerts.length > 0" class="alerts">
				<div v-for="(alert, index) in alerts" :key="index" :class="['alert-tile', 'alert-' + alert.type.toLowerCase()]" @click="manageAlert(alert)">
					<div class="title">{{ alert.title }}</div>
					<div class="alert-content">
						<div v-html="alert.content"></div>
						<img v-if="alert.video_thumbnail" :src="alert.video_thumbnail" @click="playVideo(alert.link.replace('video:',''))" style="cursor: pointer;">
					</div>
					<div v-if="alert.link.indexOf('video:') > -1" @click="playVideo(alert.link.replace('video:',''))" class="alert-link">Play Video...</div>
					<a v-else-if="alert.link.indexOf('http') > -1" :href="alert.link" class="alert-link" target="_blank">{{ alert.link_label }}...</a>
					<router-link v-else-if="alert.link" :to="alert.link" class="alert-link">{{ alert.link_label }}...</router-link>
				</div>
			</div>
			<div v-else class="empty-list">You have no<br>new messages</div>

		</div>

		<div v-if="showModal" class="video-modal">
			<div @click="showModal = false" class="close-button"><i class="fas fa-times"></i></div>
			<iframe :src="'https://player.vimeo.com/video/' + videoId" width="100%" height="75%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
		</div>

		<help-popup :helpLink="{332:'Flight Deck Dashboard'}" :tours="false"></help-popup>

	</div>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'dashboard',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
			loading: [],
			recent_orders: 0,
			store_inventory: 0,
			customer_count: 0,
			recent_dispositions: 0,
			push_packs: 0,
			opted_out: '',
			reorder_cart: 0,
			new_features: [],
			alerts: [],
			dashboardMenu: {},
			showModal: false,
			videoId: '',
			compassAPI: ''
		}
	},
	mounted() {
		if (this.getUser && this.getUser.user_id) {
			this.fetchData()
		} else {
			this.$router.push('/login')
		}
		// generate a unique id for this computer (store in localStorage) to use as the login token
		// let computerId = Math.random().toString(16).slice(2, 13) + Math.random().toString(16).slice(2, 13)
		// console.log(computerId, btoa(computerId))
	},
	computed: {
		newFeaturesColumns() {
			switch (this.new_features.length) {
				case 4:
					return 'four-columns'
					break
				case 3:
					return 'three-columns'
					break;
				case 2:
					return 'two-columns'
					break;
				case 1:
				default:
					return ''
					break
			}
		}
	},
	methods: {
		fetchData() {
            this.loading.push('getNavCenterStats')
			this.apiCall({ destination: 'get_nav_center_stats', data: { features: true, alerts: true } }).then(obj => {
				this.recent_orders = obj.recent_orders
				this.store_inventory = obj.store_inventory
				this.customer_count = obj.customer_count
				this.recent_dispositions = obj.recent_dispositions
				this.push_packs = obj.push_packs
				this.opted_out = obj.opted_out
				this.reorder_cart = obj.reorder_cart
				this.new_features = obj.new_features
				this.alerts = obj.alerts
				this.loading.splice(this.loading.indexOf('getNavCenterStats'), 1)
			}).catch(err => {
                this.loading.splice(this.loading.indexOf('getNavCenterStats'), 1)
				console.log(err)
			})

			// get dlink cart count
			if (this.getDevEnvironment) {
				this.compassAPI = 'https://compassapi.test:8088/api.php'
			} else {
				this.compassAPI = 'https://app.nssncompass.com/api.php'
			}
			this.apiCall({ destination: this.compassAPI + '?action=get_count_dlink_carts', data: { client_id: this.getClientId } })
			//.then(obj => {
			//	console.log(obj)
			//}).catch(err => {
			//	console.log(err)
			//})

		},
		manageAlert(alert) {
			// console.log('manage alert', alert)
		},
		notAllowed(menuItemId) {
            if (menuItemId in this.getMenuItemPolicies && this.getMenuItemPolicies[menuItemId].not_allowed) {
                return true
            }
            return false
        },
		playVideo(videoId) {
			if (videoId) {
				this.videoId = videoId
				this.showModal = true
			}
		}, 
		isLoading(key){
			return this.loading.includes(key);
		}
	}
}
</script>

<style lang="scss" scoped>
.popup-wrapper {
	top: 0.5em;
    right: 0.5em;
}

.loader {
    animation: rotate 1s infinite;
    height: 50px;
    width: 50px;
  }

  .loader:before,
  .loader:after {
    border-radius: 50%;
    content: "";
    display: block;
    height: 20px;
    width: 20px;
  }
  .loader:before {
    animation: ball1 1s infinite;
    background-color: #fff;
    box-shadow: 30px 0 0 #00010029;
    margin-bottom: 10px;
  }
  .loader:after {
    animation: ball2 1s infinite;
    background-color: #00010029;
    box-shadow: 30px 0 0 #fff;
  }

  @keyframes rotate {
    0% { transform: rotate(0deg) scale(0.8) }
    50% { transform: rotate(360deg) scale(1.2) }
    100% { transform: rotate(720deg) scale(0.8) }
  }

  @keyframes ball1 {
    0% {
      box-shadow: 30px 0 0 #00010029;
    }
    50% {
      box-shadow: 0 0 0 #00010029;
      margin-bottom: 0;
      transform: translate(15px, 15px);
    }
    100% {
      box-shadow: 30px 0 0 #00010029;
      margin-bottom: 10px;
    }
  }

  @keyframes ball2 {
    0% {
      box-shadow: 30px 0 0 #fff;
    }
    50% {
      box-shadow: 0 0 0 #fff;
      margin-top: -20px;
      transform: translate(15px, 15px);
    }
    100% {
      box-shadow: 30px 0 0 #fff;
      margin-top: 0;
    }
  }
  
</style>
